
import React from "react";
import Modal from "react-modal";
import classes from "../style/Style.module.css";

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={classes.Modal}
      overlayClassName={classes.Overlay}
    >
      <p className={classes.Input_Heading_text_Modal}>
        Are you sure you want to logout?
      </p>
      <div className={classes.modal_btn_containers}>
        <button onClick={onConfirm} className={classes.Selected_buttons}>
          Yes
        </button>
        <button onClick={onClose} className={classes.Selected_buttons}>
          No
        </button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
